import { GlAlert, GlButton } from '@gitlab/ui';
import { setUrlParams } from '~/lib/utils/url_utility';
import { s__, sprintf } from '~/locale';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { NAMESPACE_GROUP, NAMESPACE_PROJECT } from '~/issues/constants';
import { ERRORED_PACKAGE_TEXT } from '~/packages_and_registries/package_registry/constants';
import DeleteModal from '~/packages_and_registries/package_registry/components/delete_modal.vue';
import getPackageErrorsCountQuery from '~/packages_and_registries/package_registry/graphql/queries/get_package_errors_count.query.graphql';
export default {
    name: 'PackageErrorsCount',
    components: {
        GlAlert,
        GlButton,
        DeleteModal
    },
    inject: [
        'isGroupPage',
        'fullPath'
    ],
    emits: [
        'confirm-delete'
    ],
    apollo: {
        errorPackages: {
            query: getPackageErrorsCountQuery,
            variables () {
                return {
                    fullPath: this.fullPath,
                    isGroupPage: this.isGroupPage
                };
            },
            update (data) {
                if (!data[this.graphqlResource]) {
                    this.reportToSentry();
                }
                return data[this.graphqlResource]?.packages ?? {};
            },
            error (error) {
                this.reportToSentry(error);
            }
        }
    },
    data () {
        return {
            errorPackages: {},
            itemsToBeDeleted: []
        };
    },
    computed: {
        errorPackagesCount () {
            return this.errorPackages.count;
        },
        errorTitleAlert () {
            if (this.singleErrorPackage) {
                return sprintf(s__('PackageRegistry|There was an error publishing %{packageName}'), {
                    packageName: this.singleErrorPackage.name
                });
            }
            return sprintf(s__('PackageRegistry|There was an error publishing %{count} packages'), {
                count: this.errorPackagesCount
            });
        },
        errorMessageBodyAlert () {
            if (this.singleErrorPackage) {
                return sprintf(this.$options.i18n.errorMessageBodyAlert, {
                    message: this.singleErrorPackage.statusMessage || ERRORED_PACKAGE_TEXT
                }, false);
            }
            return sprintf(s__('PackageRegistry|Failed to publish %{count} packages. Delete these packages and try again.'), {
                count: this.errorPackagesCount
            });
        },
        graphqlResource () {
            return this.isGroupPage ? NAMESPACE_GROUP : NAMESPACE_PROJECT;
        },
        singleErrorPackage () {
            if (this.errorPackagesCount === 1) {
                const [errorPackage] = this.errorPackages.nodes;
                return errorPackage;
            }
            return null;
        },
        showErrorPackageAlert () {
            return this.errorPackagesCount > 0;
        },
        errorPackagesHref () {
            if (this.singleErrorPackage) {
                return '';
            }
            return setUrlParams({
                status: 'error'
            }, {
                url: window.location.href,
                clearParams: true
            });
        }
    },
    methods: {
        deleteItemsConfirmation () {
            this.$emit('confirm-delete', this.itemsToBeDeleted);
        },
        showConfirmationModal () {
            this.itemsToBeDeleted = [
                this.singleErrorPackage
            ];
            this.$refs.deletePackagesModal.show();
        },
        reportToSentry (error) {
            Sentry.captureException(error);
        }
    },
    i18n: {
        errorMessageBodyAlert: s__('PackageRegistry|%{message}. Delete this package and try again.')
    }
};
